module.exports = __webpack_public_path__ + "img/PlannerVid Logo 1.1dd651bc.png";